export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const USER_LOADED = "USER_LOADED";
export const SUB_USER_LOADED = "SUB_USER_LOADED";
export const SUBADMIN_AUTH_ERROR = "SUBADMIN_AUTH_ERROR";
export const SUBADMIN_LOGIN_FAIL = "SUBADMIN_LOGIN_FAIL";
export const SUBADMIN_LOGOUT = "SUBADMIN_LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_SUCCESS_SUBADMIN = "LOGIN_SUCCESS_SUBADMIN";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const PASSWORD_SUCCESS = "PASSWORD_SUCCESS";
export const PASSWORD_SUCCESS_ERROR = "PASSWORD_SUCCESS_ERROR";
export const MY_PROFILE = process.env.REACT_APP_IMAGE_URLS;
export const MY_PROFILE_COMMUNITY = process.env.REACT_APP_IMAGE_COMMUNITY_URLS;
export const MY_PROFILE_COMMUNITY_POST = process.env.REACT_APP_IMAGE_COMMUNITY_URLS_POST;

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const API_URL = process.env.REACT_APP_API_URL;

export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_SETTINGS_ERROR = "UPDATE_SETTINGS_ERROR";
export const GET_SETTINGS_LIST = "GET_SETTINGS_LIST";
export const GET_SETTINGS_LIST_ERROR = "GET_SETTINGS_LIST_ERROR";
export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_ERROR = "GET_SETTINGS_ERROR";
export const UPDATE_TOURNAMENT = "UPDATE_TOURNAMENT";
export const UPDATE_TOURNAMENT_ERROR = "UPDATE_TOURNAMENT_ERROR";
export const DELETE_TOURNAMENT = "DELETE_TOURNAMENT";
export const DELETE_TOURNAMENT_ERROR = "DELETE_TOURNAMENT_ERROR";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const ADD_CATEGORY_ERROR = "ADD_CATEGORY_ERROR";
export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const GET_CATEGORY_LIST_ERROR = "GET_CATEGORY_LIST_ERROR";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_CATEGORY_ERROR = "GET_CATEGORY_ERROR";
export const DELETE_CATEGORY_ERROR = "DELETE_CATEGORY_ERROR";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const GET_CATEGORY_PAGE = "GET_CATEGORY_PAGE";
export const GET_CATEGORY_PAGE_ERROR = "GET_CATEGORY_PAGE_ERROR";
export const ADD_SUBCATEGORY = "ADD_SUBCATEGORY";
export const ADD_SUBCATEGORY_ERROR = "ADD_SUBCATEGORY_ERROR";
export const GET_SUBCATEGORY_LIST = "GET_SUBCATEGORY_LIST";
export const GET_SUBCATEGORY_LIST_ERROR = "GET_SUBCATEGORY_LIST_ERROR";
export const GET_SUBCATEGORY = "GET_SUBCATEGORY";
export const GET_SUBCATEGORY_ERROR = "GET_SUBCATEGORY_ERROR";
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY";
export const DELETE_SUBCATEGORY_ERROR = "DELETE_SUBCATEGORY_ERROR";
export const GET_SUBCATEGORY_PAGE_ERROR = "GET_SUBCATEGORY_PAGE_ERROR";
export const GET_SUBCATEGORY_PAGE = "GET_SUBCATEGORY_PAGE";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const DELETE_QUESTION_ERROR = "DELETE_QUESTION";
export const GET_QUESTIONS_PAGE = "GET_QUESTIONS_PAGE";
export const ADD_QUESTIONS = "ADD_QUESTIONS";
export const ADD_QUESTIONS_ERROR = "ADD_QUESTIONS_ERROR";
export const GET_QUESTIONS = "GET_QUESTIONS";
export const GET_QUESTIONS_ERROR = "GET_QUESTIONS_ERROR";
export const GET_QUESTION = "GET_QUESTION";
export const GET_QUESTION_ERROR = "GET_QUESTION_ERROR";

export const ADD_GRADE = "ADD_GRADE";
export const ADD_GRADE_ERROR = "ADD_GRADE_ERROR";
export const GET_GRADE_LIST = "GET_GRADE_LIST";
export const GET_GRADE_LIST_ERROR = "GET_GRADE_LIST_ERROR";
export const GET_GRADE = "GET_GRADE";
export const GET_GRADE_ERROR = "GET_GRADE_ERROR";
export const DELETE_GRADE = "DELETE_GRADE";
export const DELETE_GRADE_ERROR = "DELETE_GRADE_ERROR";
export const GET_GRADE_PAGE_ERROR = "GET_GRADE_PAGE_ERROR";
export const GET_GRADE_PAGE = "GET_GRADE_PAGE";

export const GET_TRANSACTIONS_LIST = "GET_TRANSACTIONS_LIST";
export const GET_TRANSACTIONS_ERROR = "GET_TRANSACTIONS_ERROR";

export const GET_INVOICE = "GET_INVOICE";
export const GET_INVOICE_ERROR = "GET_INVOICE_ERROR";

export const GET_MATCHING_LIST = "GET_MATCHING_LIST";
export const GET_MATCHING_ERROR = "GET_MATCHING_ERROR";
export const CLIENT = "CLIENT";

export const ALLEVENTS = "ALLEVENTS";
export const ALLFILTEREDEVENTS = "ALLFILTEREDEVENTS";

export const SET_LOADING = "SET_LOADING";
export const SIDEBAR_TOGGLE = "SIDEBAR_TOGGLE";
